module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "purple"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Material Dashboard Heading")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Created using Roboto Font Family")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    attrs: {
      "id": "typography"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Typography")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "tim-typo"
  }, [_c('h1', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 1")]), _vm._v("The Life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h2', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 2")]), _vm._v("The life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h3', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 3")]), _vm._v("The life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h4', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 4")]), _vm._v("The life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h5', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 5")]), _vm._v("The life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h6', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Header 6")]), _vm._v("The life of Material Dashboard ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('p', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Paragraph")]), _vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers. I understand culture. I am the nucleus. I think that’s a responsibility that I have, to push possibilities, to show people, this is the level that things could be at.")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Quote")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("\n                      I will be the leader of a company that ends up being worth billions of dollars, because I got the answers. I understand culture. I am the nucleus. I think that’s a responsibility that I have, to push possibilities, to show people, this is the level that things could be at.\n                    ")]), _vm._v(" "), _c('small', [_vm._v("\n                      Kanye West, Musician\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Muted Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Primary Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-primary"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Info Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-info"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Success Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-success"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Warning Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-warning"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Danger Text")]), _vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n                    I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "tim-typo"
  }, [_c('h2', [_c('span', {
    staticClass: "tim-note"
  }, [_vm._v("Small Tag")]), _vm._v("\n                    Header with small subtitle "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Use \"small\" tag for the headers")])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b599e7a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Typography.vue
// module id = 173
// module chunks = 2